import React from 'react';

// Icon wrapper for consistent sizing
const IconWrapper = ({ children, size = 24, color = 'currentColor', className = '' }) => (
 <svg
 width={size}
 height={size}
 viewBox="0 0 24 24"
 fill="none"
 stroke={color}
 strokeWidth="2"
 strokeLinecap="round"
 strokeLinejoin="round"
 className={className}
 >
 {children}
 </svg>
);

// Bio Icon (Mobile style)
export const BioIcon = ({ size = 17, color = '#434F4D' }) => (
 <svg width={size} height={size * 1.24} viewBox="0 0 17 21" fill="none">
 <path d="M1 2.9966L2.70104 5.5282C-0.677083 9.2657 4.59375 19.3681 8.58681 19.3681C12.5799 19.3681 18.3618 9.02612 14.5365 5.26466L15.7264 2.14209" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M7.34086 1V2.91667C6.41854 2.92354 5.52381 3.23207 4.79329 3.79514L3.41968 1.79861" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M13.067 1.39931L12.2684 3.54757C11.6306 3.1551 10.9007 2.9375 10.1521 2.91667V1" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M1.78271 10.4634C5.33653 9.59293 4.17855 10.1759 6.94973 7.20508" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M5.552 8.72266L6.40652 10.1841" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M11.0386 3.03662L10.5355 3.7953C10.2866 4.14825 10.1584 4.57212 10.1699 5.00382C10.1814 5.43552 10.332 5.85196 10.5993 6.19114" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M15.7824 8.98604H14.0334C13.3477 8.97802 12.6819 9.21602 12.1567 9.65687L11.0706 10.5833" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M12.7557 16.573L11.7574 16.4053C11.4053 16.3493 11.0679 16.2237 10.7648 16.0359C10.4618 15.848 10.1992 15.6016 9.99248 15.3112L9.0022 13.7778" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M3.00439 14.1133L6.74189 14.5765" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

// Sleep Icon (Mobile style - from insights.tsx)
export const SleepIcon = ({ size = 17, color = '#434F4D' }) => (
 <svg width={size * 1.53} height={size * 1.24} viewBox="0 0 33 26" fill="none">
 <path
 d="M28.7124 11.12C27.9884 10.7933 27.2061 10.6249 26.4154 10.6256H5.74248C4.95182 10.6248 4.16962 10.7929 3.44549 11.1192C2.42204 11.5793 1.55114 12.336 0.93925 13.2966C0.327359 14.2573 0.000977978 15.3804 0 16.5287V24.7931C0 25.1062 0.121002 25.4065 0.336387 25.6279C0.551772 25.8493 0.843896 25.9737 1.1485 25.9737C1.4531 25.9737 1.74522 25.8493 1.96061 25.6279C2.17599 25.4065 2.29699 25.1062 2.29699 24.7931V24.2028C2.29885 24.0468 2.35995 23.8977 2.46724 23.7875C2.57454 23.6772 2.71952 23.6144 2.87124 23.6124H29.2867C29.4384 23.6144 29.5834 23.6772 29.6907 23.7875C29.7979 23.8977 29.859 24.0468 29.8609 24.2028V24.7931C29.8609 25.1062 29.9819 25.4065 30.1973 25.6279C30.4127 25.8493 30.7048 25.9737 31.0094 25.9737C31.314 25.9737 31.6061 25.8493 31.8215 25.6279C32.0369 25.4065 32.1579 25.1062 32.1579 24.7931V16.5287C32.1568 15.3806 31.8303 14.2576 31.2184 13.2971C30.6066 12.3365 29.7357 11.58 28.7124 11.12ZM24.6927 0H7.46523C6.39913 0 5.37669 0.435353 4.62284 1.21029C3.869 1.98522 3.44549 3.03626 3.44549 4.13218V9.44498C3.44552 9.49071 3.45589 9.53582 3.47579 9.57673C3.49568 9.61764 3.52455 9.65324 3.56012 9.68072C3.59569 9.7082 3.63699 9.7268 3.68075 9.73506C3.72451 9.74332 3.76954 9.74102 3.81229 9.72832C4.43927 9.53982 5.08924 9.4444 5.74248 9.44498H6.04612C6.11699 9.44544 6.18552 9.41894 6.23852 9.37058C6.29153 9.32222 6.32527 9.25542 6.33324 9.18303C6.39588 8.60614 6.66305 8.07318 7.08371 7.68594C7.50437 7.29871 8.04905 7.08432 8.61372 7.08373H12.6335C13.1985 7.08378 13.7437 7.29792 14.1648 7.68521C14.5859 8.0725 14.8534 8.60576 14.9161 9.18303C14.9241 9.25542 14.9578 9.32222 15.0108 9.37058C15.0638 9.41894 15.1323 9.44544 15.2032 9.44498H16.959C17.0299 9.44544 17.0984 9.41894 17.1514 9.37058C17.2044 9.32222 17.2381 9.25542 17.2461 9.18303C17.3087 8.60652 17.5756 8.07387 17.9958 7.68668C18.416 7.29949 18.9601 7.08486 19.5244 7.08373H23.5442C24.1092 7.08378 24.6544 7.29792 25.0755 7.68521C25.4967 8.0725 25.7641 8.60576 25.8268 9.18303C25.8348 9.25542 25.8685 9.32222 25.9215 9.37058C25.9745 9.41894 26.043 9.44544 26.114 9.44498H27.8588C28.5038 9.44498 29.1418 9.53982 29.7581 9.72832C29.8018 9.74102 29.8478 9.74332 29.8925 9.73506C29.9373 9.7268 29.9796 9.7082 30.0162 9.68072C30.0528 9.65324 30.0828 9.61764 30.1038 9.57673C30.1248 9.53582 30.1359 9.49071 30.1359 9.44498V4.13218C30.1359 3.03626 29.7124 1.98522 28.9586 1.21029C28.2047 0.435353 27.1823 0 26.1162 0H24.6927Z"
 fill={color}
 />
 </svg>
);

// Heart Rate Icon (Mobile style)
export const HeartRateIcon = ({ size = 13, color = '#434F4D' }) => (
 <svg width={size} height={size} viewBox="0 0 13 13" fill="none">
 <path d="M3.59912 5.58283H4.95903L5.61397 4.27637L6.87309 6.81589L7.83725 5.58276H9.15461" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M6.22448 1.55977L6.50003 1.85707L6.77552 1.55977C8.08512 0.146742 10.2083 0.146742 11.5178 1.55977C12.8274 2.9728 12.8274 5.26378 11.5178 6.67683L6.50003 12.0911L1.48217 6.67683C0.172611 5.26378 0.172611 2.9728 1.48217 1.55977C2.79172 0.146742 4.91493 0.146742 6.22448 1.55977Z" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

// Brain / Burnout Icon (Mobile style)
export const BrainIcon = ({ size = 12, color = '#434F4D' }) => (
 <svg width={size} height={size * 0.92} viewBox="0 0 12 11" fill="none">
 <path d="M4.791 7.80637C4.791 7.42773 4.62695 7.06459 4.33491 6.79681C4.04288 6.52903 3.64678 6.37853 3.23371 6.37842C3.20832 6.37842 3.1858 6.38413 3.1604 6.38545" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M4.62905 2.1567C4.79624 2.10503 4.94462 2.01205 5.05784 1.88801C5.17106 1.76397 5.24473 1.61369 5.27073 1.45372C5.29673 1.29376 5.27405 1.13032 5.20519 0.981412C5.13633 0.832508 5.02396 0.703919 4.88046 0.609815C4.73697 0.515712 4.56792 0.459747 4.39195 0.448087C4.21597 0.436427 4.0399 0.469525 3.88314 0.543734C3.72637 0.617943 3.595 0.730382 3.50349 0.868661C3.41198 1.00694 3.3639 1.16569 3.36453 1.32742C3.36584 1.40685 3.3789 1.48576 3.40334 1.56197C3.35016 1.55802 3.29889 1.54704 3.24474 1.54704C2.90921 1.54547 2.57998 1.63047 2.29466 1.79231C2.00934 1.95415 1.77944 2.1863 1.63125 2.46226C1.48306 2.7382 1.42255 3.0468 1.45664 3.35278C1.49072 3.65875 1.61803 3.94977 1.82401 4.19256C1.46179 4.21451 1.12222 4.36188 0.874144 4.60482C0.626066 4.84775 0.488037 5.16806 0.488037 5.50082C0.488037 5.83358 0.626066 6.1539 0.874144 6.39683C1.12222 6.63976 1.46179 6.78714 1.82401 6.80909C1.61826 7.05184 1.49115 7.34275 1.45719 7.64858C1.42323 7.95441 1.4838 8.26283 1.63198 8.53861C1.78015 8.81438 2.00996 9.04639 2.29514 9.20813C2.58032 9.36988 2.90939 9.45483 3.24474 9.45329C3.29889 9.45329 3.35016 9.44319 3.40334 9.43879C3.3523 9.60431 3.35539 9.77991 3.41222 9.94383C3.46905 10.1077 3.57712 10.2528 3.72303 10.3609C3.86894 10.469 4.04627 10.5355 4.23303 10.5521C4.41979 10.5687 4.60775 10.5347 4.77361 10.4543C4.93947 10.3739 5.07593 10.2506 5.16606 10.0997C5.25619 9.94889 5.29603 9.77711 5.28064 9.60569C5.26525 9.43427 5.1953 9.27077 5.07947 9.13546C4.96364 9.00015 4.80703 8.89898 4.62905 8.84451" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M3.1604 4.61526C3.18532 4.61526 3.20832 4.62185 3.23371 4.62185C3.64669 4.62174 4.04272 4.4713 4.33474 4.20361C4.62677 3.93593 4.79088 3.5729 4.791 3.19434" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M7.20898 7.80637C7.20898 7.42773 7.37304 7.06459 7.66508 6.79681C7.95711 6.52903 8.35321 6.37853 8.76628 6.37842C8.79167 6.37842 8.81419 6.38413 8.83959 6.38545" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M7.37089 2.1567C7.2037 2.10503 7.05532 2.01205 6.9421 1.88801C6.82888 1.76397 6.75521 1.61369 6.72921 1.45372C6.70321 1.29376 6.72589 1.13032 6.79475 0.981412C6.86361 0.832508 6.97598 0.703919 7.11947 0.609815C7.26297 0.515712 7.43201 0.459747 7.60799 0.448087C7.78396 0.436427 7.96004 0.469525 8.1168 0.543734C8.27357 0.617943 8.40494 0.730382 8.49645 0.868661C8.58795 1.00694 8.63604 1.16569 8.63541 1.32742C8.6341 1.40685 8.62104 1.48576 8.59659 1.56197C8.64978 1.55758 8.70105 1.54704 8.7552 1.54704C9.09064 1.54554 9.41978 1.63055 9.70502 1.79238C9.99025 1.9542 10.2201 2.1863 10.3683 2.46216C10.5164 2.73803 10.577 3.04654 10.543 3.35245C10.509 3.65835 10.3818 3.94932 10.1759 4.19212C10.5381 4.21407 10.8777 4.36145 11.1258 4.60438C11.3739 4.84731 11.5119 5.16762 11.5119 5.50038C11.5119 5.83314 11.3739 6.15346 11.1258 6.39639C10.8777 6.63932 10.5381 6.7867 10.1759 6.80865C10.3818 7.0514 10.509 7.34235 10.5431 7.64825C10.5771 7.95415 10.5166 8.26266 10.3684 8.53851C10.2202 8.81436 9.99033 9.04643 9.70506 9.2082C9.41979 9.36996 9.09063 9.4549 8.7552 9.45329C8.70105 9.45329 8.64978 9.44319 8.59659 9.43879C8.64763 9.60431 8.64455 9.77991 8.58772 9.94383C8.53089 10.1077 8.42282 10.2528 8.27691 10.3609C8.13099 10.469 7.95366 10.5355 7.76691 10.5521C7.58015 10.5687 7.39219 10.5347 7.22633 10.4543C7.06047 10.3739 6.92401 10.2506 6.83387 10.0997C6.74374 9.94889 6.7039 9.77711 6.7193 9.60569C6.73469 9.43427 6.80464 9.27077 6.92047 9.13546C7.0363 9.00015 7.19291 8.89898 7.37089 8.84451" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M8.83959 4.61526C8.81467 4.61526 8.79167 4.62185 8.76628 4.62185C8.3533 4.62174 7.95727 4.4713 7.66524 4.20361C7.37322 3.93593 7.20911 3.5729 7.20898 3.19434" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M5.28125 0.283473C5.49978 0.16782 5.74767 0.106934 6 0.106934C6.25233 0.106934 6.50022 0.16782 6.71875 0.283473" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M6 3.3042V7.91618" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

// Person / Potential Icon (Mobile style)
export const PersonIcon = ({ size = 10, color = '#434F4D' }) => (
 <svg width={size} height={size * 1.3} viewBox="0 0 10 13" fill="none">
 <g transform="translate(3, 0)">
 <path d="M2 3.5C2.82843 3.5 3.5 2.82843 3.5 2C3.5 1.17157 2.82843 0.5 2 0.5C1.17157 0.5 0.5 1.17157 0.5 2C0.5 2.82843 1.17157 3.5 2 3.5Z" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
 </g>
 <g transform="translate(0, 3)">
 <path d="M6.0526 7.01534L5.00366 4.95761L3.95472 7.01534C3.81169 7.29777 3.43025 7.49951 3.0965 7.49951C2.95346 7.49951 2.81042 7.45916 2.71507 7.41882C2.23827 7.21708 2.04756 6.77325 2.23827 6.36978L3.71633 3.46475V2.94023L1.09397 2.05258C0.617183 1.89119 0.378782 1.44737 0.569499 1.04389C0.773494 0.612325 1.28545 0.382444 1.80916 0.559715C2.33288 0.736991 3.19186 1.04389 4.09776 1.32632C4.39146 1.42988 4.69775 1.48028 5.00366 1.47752C5.30962 1.48028 5.61586 1.42988 5.90957 1.32632C6.81547 1.04389 7.67446 0.736991 8.19817 0.559715C8.72187 0.382444 9.23385 0.612325 9.43782 1.04389C9.62854 1.44737 9.39015 1.89119 8.91335 2.05258L6.291 2.94023V3.46475L7.76905 6.36978C7.95977 6.77325 7.76905 7.21708 7.29226 7.41882C7.1969 7.45916 7.05387 7.49951 6.91083 7.49951C6.57707 7.49951 6.19564 7.29777 6.0526 7.01534Z" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
 </g>
 </svg>
);

// Lightning / Regen Icon (Mobile style)
export const LightningIcon = ({ size = 14, color = '#434F4D' }) => (
 <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
 <path d="M8 0.5V5.5H11.5L6 13.5V8.5H2.5L8 0.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

// Running / Activity Icon (Standard)
export const RunningIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
 <IconWrapper size={size} color={color} className={className}>
 <circle cx="12" cy="5" r="2" fill={color} stroke="none" />
 <path d="M4 17l4-4 2 2 4-6 4 4" />
 <path d="M15 21l-3-3-2 2-4-4" />
 </IconWrapper>
);

// Lotus / Meditation Icon (Mobile design - from insights.tsx)
export const LotusIcon = ({ size = 24, color = '#434F4D', className = '' }) => (
 <svg width={size} height={size} viewBox="0 0 33 33" fill="none" className={className}>
 <path d="M16.5 28.46C16.32 28.46 16.16 28.4 16.03 28.28C14.16 26.61 12.67 24.57 11.65 22.29C10.63 20.01 10.1 17.54 10.1 15.04C10.1 12.54 10.63 10.07 11.65 7.79C12.67 5.51 14.16 3.47 16.03 1.8C16.16 1.69 16.32 1.62 16.5 1.62C16.67 1.62 16.84 1.69 16.97 1.8C18.84 3.47 20.33 5.51 21.35 7.79C22.37 10.07 22.9 12.54 22.9 15.04C22.9 17.54 22.37 20.01 21.35 22.29C20.33 24.57 18.84 26.61 16.97 28.28C16.84 28.4 16.67 28.46 16.5 28.46Z" fill="#F2F2F2" />
 <path d="M15.79 24.28C15.79 20.47 14.39 16.79 11.86 13.93C9.34 11.08 5.86 9.24 2.07 8.77C1.9 8.75 1.72 8.79 1.58 8.89C1.43 8.99 1.33 9.14 1.29 9.32C0.75 11.58 0.72 13.93 1.2 16.2C1.69 18.47 2.67 20.61 4.09 22.45C5.51 24.29 7.31 25.79 9.39 26.85C11.46 27.9 13.74 28.47 16.06 28.53L16.5 28.54C15.99 27.18 15.75 25.73 15.79 24.28Z" fill="#F2F2F2" />
 <path d="M17.21 24.28C17.21 20.47 18.61 16.79 21.13 13.93C23.66 11.08 27.14 9.24 30.93 8.77C31.1 8.75 31.28 8.79 31.42 8.89C31.57 8.99 31.67 9.14 31.71 9.32C32.25 11.58 32.28 13.93 31.8 16.2C31.31 18.47 30.33 20.61 28.91 22.45C27.49 24.29 25.68 25.79 23.61 26.85C21.54 27.9 19.26 28.47 16.94 28.53L16.5 28.54C17.01 27.18 17.25 25.73 17.21 24.28Z" fill="#F2F2F2" />
 <path d="M16.5 28.54C16.32 28.54 16.16 28.48 16.02 28.36C14.95 27.4 14.09 26.22 13.5 24.91C12.91 23.59 12.6 22.17 12.6 20.73C12.6 19.28 12.91 17.86 13.5 16.54C14.09 15.23 14.95 14.05 16.02 13.09C16.16 12.97 16.32 12.91 16.5 12.91C16.67 12.91 16.84 12.97 16.97 13.09C18.05 14.05 18.91 15.23 19.5 16.54C20.09 17.86 20.39 19.28 20.39 20.73C20.39 22.17 20.09 23.59 19.5 24.91C18.91 26.22 18.05 27.4 16.97 28.36C16.84 28.48 16.67 28.54 16.5 28.54Z" fill="#F2F2F2" />
 <path d="M9.26 31.38C8.91 31.38 8.56 31.36 8.2 31.33C6.61 31.18 5.07 30.69 3.69 29.9C2.3 29.12 1.09 28.05 0.14 26.76C0.04 26.62 -0.01 26.45 0 26.27C0.02 26.1 0.1 25.93 0.23 25.82C1.4 24.73 2.79 23.9 4.3 23.39C5.81 22.88 7.42 22.69 9.01 22.84C10.6 22.99 12.14 23.48 13.53 24.26C14.92 25.05 16.13 26.12 17.07 27.41C17.18 27.55 17.22 27.72 17.21 27.9C17.19 28.07 17.11 28.24 16.98 28.35C14.88 30.3 12.12 31.38 9.26 31.38Z" fill="#F2F2F2" />
 <path d="M16.02 28.35C15.89 28.24 15.81 28.07 15.79 27.9C15.78 27.72 15.82 27.55 15.93 27.41C16.87 26.12 18.08 25.05 19.47 24.26C20.86 23.48 22.4 22.99 23.99 22.84C25.58 22.69 27.19 22.88 28.7 23.39C30.21 23.9 31.6 24.73 32.77 25.82C32.9 25.93 32.98 26.1 33 26.27C33.01 26.45 32.96 26.62 32.86 26.76C31.91 28.05 30.7 29.12 29.31 29.9C27.93 30.69 26.39 31.18 24.8 31.33C24.44 31.36 24.09 31.38 23.74 31.38C20.88 31.38 18.12 30.3 16.02 28.35Z" fill="#F2F2F2" />
 </svg>
);

// Walk / Activity Icon (Mobile design - from insights.tsx)
export const WalkIcon = ({ size = 20, color = '#FFFFFF', className = '' }) => (
  <svg width="30" height="28" viewBox="0 0 47 43" fill="none" className={className}>
    <path
      d="M13.7083 37.625L19.5833 30.4583M31.3333 37.625L27.4167 30.4583L21.5417 25.0833L23.5 14.3333M23.5 14.3333L15.6667 16.125L11.75 21.5M23.5 14.3333L29.375 19.7083L35.25 21.5M23.5 7.16667C23.5 7.64185 23.7063 8.09756 24.0736 8.43357C24.4408 8.76957 24.939 8.95833 25.4583 8.95833C25.9777 8.95833 26.4758 8.76957 26.8431 8.43357C27.2103 8.09756 27.4167 7.64185 27.4167 7.16667C27.4167 6.69149 27.2103 6.23577 26.8431 5.89977C26.4758 5.56376 25.9777 5.375 25.4583 5.375C24.939 5.375 24.4408 5.56376 24.0736 5.89977C23.7063 6.23577 23.5 6.69149 23.5 7.16667Z"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ActivityIcon alias for backward compatibility
export const ActivityIcon = WalkIcon;

// Trend Arrow Icon
export const TrendArrowIcon = ({ opacity = 1, size = 51, color = "#F3F3F3" }) => (
 <svg width={size} height={size * 0.59} viewBox="0 0 51 30" fill="none" style={{ opacity }}>
 <path d="M33.8572 3H47.5715V16.7143" stroke={color} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M47.5714 3L28.2 22.3714C27.8796 22.6855 27.4487 22.8615 27 22.8615C26.5513 22.8615 26.1205 22.6855 25.8 22.3714L17.9143 14.4857C17.5938 14.1716 17.163 13.9957 16.7143 13.9957C16.2656 13.9957 15.8347 14.1716 15.5143 14.4857L3 27" stroke={color} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);


// Water Drop Filled
export const WaterDropIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className}>
 <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>
 </svg>
);

// Medication / Pill Icon
export const MedicationIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
 <path d="M10.5 20.5L3.5 13.5a4.95 4.95 0 1 1 7-7l7 7a4.95 4.95 0 0 1-7 7z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M8.5 8.5l7 7" stroke={color} strokeWidth="2" strokeLinecap="round"/>
 </svg>
);

// Timer / Stopwatch Icon
export const TimerIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
 <circle cx="12" cy="14" r="8" stroke={color} strokeWidth="2"/>
 <path d="M12 10v4l2 2" stroke={color} strokeWidth="2" strokeLinecap="round"/>
 <path d="M9 2h6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
 <path d="M12 2v2" stroke={color} strokeWidth="2" strokeLinecap="round"/>
 </svg>
);

// Fire / Calories Icon
export const FireIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
 <path d="M12 22c4.97 0 9-4.03 9-9 0-4.42-2.87-8.17-6.84-9.49-.35-.12-.66.22-.52.56.58 1.43.36 3.06-.63 4.26C11.84 9.76 12 11.38 12 13c0 1.1-.9 2-2 2s-2-.9-2-2c0-.62.08-1.22.23-1.79.15-.57-.35-1.08-.87-.79C4.69 12.05 3 14.84 3 18c0 2.21 1.79 4 4 4h5z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

// Fire Filled
export const FireFilledIcon = ({ size = 24, color = '#ff6b35', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className}>
 <path d="M12 22c4.97 0 9-4.03 9-9 0-4.42-2.87-8.17-6.84-9.49-.35-.12-.66.22-.52.56.58 1.43.36 3.06-.63 4.26C11.84 9.76 12 11.38 12 13c0 1.1-.9 2-2 2s-2-.9-2-2c0-.62.08-1.22.23-1.79.15-.57-.35-1.08-.87-.79C4.69 12.05 3 14.84 3 18c0 2.21 1.79 4 4 4h5z"/>
 </svg>
);

// Trending Up Icon
export const TrendingUpIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
 <polyline points="17 6 23 6 23 12"/>
 </svg>
);

// Trending Down Icon
export const TrendingDownIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/>
 <polyline points="17 18 23 18 23 12"/>
 </svg>
);

// Check Circle Icon
export const CheckCircleIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
 <polyline points="22 4 12 14.01 9 11.01"/>
 </svg>
);

// Plus Icon
export const PlusIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <line x1="12" y1="5" x2="12" y2="19"/>
 <line x1="5" y1="12" x2="19" y2="12"/>
 </svg>
);

// Settings / Gear Icon
export const SettingsIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <circle cx="12" cy="12" r="3"/>
 <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
 </svg>
);

// Lightbulb / Tips Icon
export const LightbulbIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M9 18h6"/>
 <path d="M10 22h4"/>
 <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"/>
 </svg>
);

// Sun Icon
export const SunIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <circle cx="12" cy="12" r="5"/>
 <line x1="12" y1="1" x2="12" y2="3"/>
 <line x1="12" y1="21" x2="12" y2="23"/>
 <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
 <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
 <line x1="1" y1="12" x2="3" y2="12"/>
 <line x1="21" y1="12" x2="23" y2="12"/>
 <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
 <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
 </svg>
);

// Heart Icon (filled)
export const HeartIcon = ({ size = 24, color = '#ff6b6b', className = '' }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className}>
 <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
 </svg>
);

// Heart Outline Icon
export const HeartOutlineIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
 </svg>
);

// Yoga Icon
export const YogaIcon = ({ size = 24, color = '#434F4D', className = '' }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
 <path d="M12 22c-4 0-8-2-8-6 0-2 2-4 4-4 0-2 2-4 4-4s4 2 4 4c2 0 4 2 4 4 0 4-4 6-8 6z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M12 22v-6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
 <circle cx="12" cy="6" r="2" stroke={color} strokeWidth="2"/>
 </svg>
);

// Nutrition Icon
export const NutritionIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
 <path d="M12 2c1 0 2 1 2 2-1 0-2-1-2-2z" stroke={color} strokeWidth="2" strokeLinecap="round"/>
 <path d="M15.5 6.5C18 6.5 20 9 20 12.5c0 5-3 8.5-8 8.5s-8-3.5-8-8.5C4 9 6 6.5 8.5 6.5c1.5 0 2.5.5 3.5 1.5 1-1 2-1.5 3.5-1.5z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

// Hydration Icon
export const HydrationIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
 <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

// Mindfulness Icon
export const MindfulnessIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
 <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
 <path d="M12 6v6l4 2" stroke={color} strokeWidth="2" strokeLinecap="round"/>
 <circle cx="12" cy="12" r="2" fill={color}/>
 </svg>
);

// Moon Filled Icon
export const MoonFilledIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className}>
 <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
 </svg>
);

// Walking Icon (Aliased for compatibility)
export const WalkingIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
 <WalkIcon size={size} color={color} className={className} />
);

// Dumbbell / Strength Icon
export const StrengthIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M6.5 6.5L17.5 17.5"/>
 <path d="M3 10l1-1 3 3-1 1z"/>
 <path d="M7 6l1-1 3 3-1 1z"/>
 <path d="M14 17l1-1 3 3-1 1z"/>
 <path d="M18 13l1-1 3 3-1 1z"/>
 </svg>
);

// Bike / Cycling Icon
export const CyclingIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <circle cx="5.5" cy="17.5" r="3.5"/>
 <circle cx="18.5" cy="17.5" r="3.5"/>
 <circle cx="15" cy="5" r="1"/>
 <path d="M12 17.5V14l-3-3 4-3 2 3h3"/>
 </svg>
);

// Swimming Icon
export const SwimmingIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <circle cx="16" cy="4" r="2"/>
 <path d="M2 18c1.5 0 3-1 3-1s1.5 1 3 1 3-1 3-1 1.5 1 3 1 3-1 3-1 1.5 1 3 1"/>
 <path d="M2 22c1.5 0 3-1 3-1s1.5 1 3 1 3-1 3-1 1.5 1 3 1 3-1 3-1 1.5 1 3 1"/>
 <path d="M11 12l-2-2 7-4 2 4-4 2"/>
 </svg>
);

// Brain / Mental Icon (Legacy - consider removing if not used)
export const LegacyBrainIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"/>
 <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"/>
 <path d="M12 5v13"/>
 </svg>
);

// Zap / Energy Icon
export const ZapIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
 </svg>
);

// Chart / Analytics Icon
export const ChartIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <line x1="18" y1="20" x2="18" y2="10"/>
 <line x1="12" y1="20" x2="12" y2="4"/>
 <line x1="6" y1="20" x2="6" y2="14"/>
 </svg>
);

// Calendar Icon
export const CalendarIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
 <line x1="16" y1="2" x2="16" y2="6"/>
 <line x1="8" y1="2" x2="8" y2="6"/>
 <line x1="3" y1="10" x2="21" y2="10"/>
 </svg>
);

// Clock Icon
export const ClockIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <circle cx="12" cy="12" r="10"/>
 <polyline points="12 6 12 12 16 14"/>
 </svg>
);

// User Icon
export const UserIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
 <circle cx="12" cy="7" r="4"/>
 </svg>
);

// Edit Icon
export const EditIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
 <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
 </svg>
);

// Trash / Delete Icon
export const TrashIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <polyline points="3 6 5 6 21 6"/>
 <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
 </svg>
);

// Chevron Down Icon
export const ChevronDownIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <polyline points="6 9 12 15 18 9"/>
 </svg>
);

// Chevron Right Icon
export const ChevronRightIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <polyline points="9 18 15 12 9 6"/>
 </svg>
);

// Close / X Icon
export const CloseIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <line x1="18" y1="6" x2="6" y2="18"/>
 <line x1="6" y1="6" x2="18" y2="18"/>
 </svg>
);

// Search Icon
export const SearchIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <circle cx="11" cy="11" r="8"/>
 <line x1="21" y1="21" x2="16.65" y2="16.65"/>
 </svg>
);

// Email Icon
export const EmailIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
 <polyline points="22,6 12,13 2,6"/>
 </svg>
);

// Message / Chat Icon
export const MessageIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
 </svg>
);

// Book / Help Icon
export const BookIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
 <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
 </svg>
);

// Heart Impulse Icon (for Impulse metric)
export const HeartImpulseIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M3.22 12H9.5l.76-1.52a2 2 0 0 1 3.58 0l.76 1.52h6.28"/>
 <path d="M3.22 12a9 9 0 0 0 17.56 0"/>
 <path d="M12 2v4"/>
 <path d="M12 18v4"/>
 </svg>
);

// Help Circle Icon (for tooltips)
export const HelpCircleIcon = ({ size = 18, color = '#A0ABA8', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <circle cx="12" cy="12" r="10"/>
 <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
 <line x1="12" y1="17" x2="12.01" y2="17"/>
 </svg>
);

// Star Icon
export const StarIcon = ({ size = 24, color = 'currentColor', filled = false, className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill={filled ? color : 'none'} stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
 </svg>
);

// Arrow Up Icon (for Max HR)
export const ArrowUpIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M12 19V5"/>
 <polyline points="5 12 12 5 19 12"/>
 </svg>
);

// Arrow Down Icon (for Min HR)
export const ArrowDownIcon = ({ size = 24, color = 'currentColor', className }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
 <path d="M12 5v14"/>
 <polyline points="19 12 12 19 5 12"/>
 </svg>
);

// Export all icons as a map for easy dynamic usage
export const IconMap = {
 activity: WalkIcon,
 heartRate: HeartRateIcon,
 heart: HeartIcon,
 heartOutline: HeartOutlineIcon,
 mindfulness: MindfulnessIcon,
 yoga: YogaIcon,
 sleep: SleepIcon,
 moon: MoonFilledIcon,
 nutrition: NutritionIcon,
 hydration: HydrationIcon,
 waterDrop: WaterDropIcon,
 medication: MedicationIcon,
 timer: TimerIcon,
 fire: FireIcon,
 fireFilled: FireFilledIcon,
 trendingUp: TrendingUpIcon,
 trendingDown: TrendingDownIcon,
 checkCircle: CheckCircleIcon,
 plus: PlusIcon,
 settings: SettingsIcon,
 lightbulb: LightbulbIcon,
 sun: SunIcon,
 walking: WalkingIcon,
 strength: StrengthIcon,
 cycling: CyclingIcon,
 swimming: SwimmingIcon,
 brain: BrainIcon,
 zap: ZapIcon,
 chart: ChartIcon,
 calendar: CalendarIcon,
 clock: ClockIcon,
 user: UserIcon,
 edit: EditIcon,
 trash: TrashIcon,
 chevronDown: ChevronDownIcon,
 chevronRight: ChevronRightIcon,
 close: CloseIcon,
 search: SearchIcon,
 email: EmailIcon,
 message: MessageIcon,
 book: BookIcon,
 star: StarIcon,
 arrowUp: ArrowUpIcon,
 arrowDown: ArrowDownIcon,
 heartImpulse: HeartImpulseIcon,
 helpCircle: HelpCircleIcon,
};

export default IconMap;

// --- Mobile Onboarding Icons ---

// Mobile onboarding icons
const MOBILE_ICONS = {
 chart: require('../assets/onboarding/fi-ss-chart-histogram.png'),
 heart: require('../assets/onboarding/heart-rate-pulse-graph.png'),
 watch: require('../assets/onboarding/Watch.png'),
 vector: require('../assets/onboarding/Vector.png'),
};

// MobileIcon component for PNG-based mobile onboarding icons
export function MobileIcon({ name, size = 20, className = '' }) {
 const iconSrc = MOBILE_ICONS[name];
 
 if (!iconSrc) {
 return null;
 }

 return (
 <img 
 src={iconSrc} 
 alt="" 
 className={`mobile-icon ${className}`}
 style={{ width: size, height: size, objectFit: 'contain' }}
 />
 );
}